import { EventEmitter } from "./EventEmmitter";

class BaseStore extends EventEmitter {
    public ServerDispatchToken: any;

    private Data: { [key: string]: any } = {};

    constructor() {
        super();
    }

    public EmitChangeToListeners(debugInfo?: string): void {
        if (debugInfo)
            console.log("emit from", debugInfo);

        this.Emit("Change");
    }

    public AddChangeListener(event: any, context: React.Component<any, any>, debugName?: string): string {
        return this.AddListener("Change", event, context, debugName);
    }

    public RemoveChangeListener(id: string): void {
        this.RemoveListener(id);
    }

    public Get<T>(field: string): T | null {
        if (this.HasData(field))
            return this.Data[field];
        else
            return null;
    }

    public Set<T>(field: string, value: T): void {
        if (value != null)
            this.Data[field] = value;
    }

    public HasData(field: string): boolean {
        if (this.Data != null)
            return field in this.Data;
        else
            return false;
    }

    /**
     * Create a singleton instance of a store, or throw an error if it's already initialized.
     * @constructor
     * @param {TStore} defaultInstance - The singleton instance.
     * @param {() => TStore} create - A callback which creates the singleton if needed.
     */
    protected static createStoreSingleton<TStore>(defaultInstance: TStore, create: () => TStore): TStore {
        if (defaultInstance)
            throw new Error("The store singleton has already been initialized. The createSingleton() method should only be called from the app entry point.");

        return create();
    }
}

export { BaseStore };
